import Vue from 'vue'
import moment from 'moment'
import './plugins/vuetify'
import './assets/inventory-theme.css'
import App from './App.vue'
import {
    router
} from './router'
import store from './store'
import {
    formatToMoney
} from "@/utils";

// setup fake backend
// import { configureFakeBackend } from './_helpers';
// configureFakeBackend();
Vue.config.productionTip = false
Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(String(value)).format('DD.MM.YYYY HH:mm')
    }
});
Vue.filter('formatMoney', function (value) {
    if (value === null || value === undefined) {
        return '';
    }
    return formatToMoney(value);
});
Vue.filter('formatState', function (value) {
    var result = store.getters['orders/getStateItems'].find(el => el.id == value);
    return result.value;
});
Vue.filter('formatHbState', function (value) {
    var result = store.getters['orders/getHbStateItems'].find(el => el.id == value);
    return result == null ? value : result.value;
});
Vue.filter('formatUyumStates', function (value) {
    var result = store.state.orders.uyumStates.find(el => el.id == value);
    return result.value;
});


window.Vue = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')